import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import enCommon from '../locales/en/common.json'
import enDashboard from '../locales/en/dashboard.json'
import enCalls from '../locales/en/calls.json'
import enCampaigns from '../locales/en/campaigns.json'
import enSimulations from '../locales/en/simulations.json'
import enContacts from '../locales/en/contacts.json'
import enAgents from '../locales/en/agents.json'
import enFollowups from '../locales/en/followups.json'
import enDirectory from '../locales/en/directory.json'
import enBilling from '../locales/en/billing.json'
import enAuth from '../locales/en/auth.json'
import enErrors from '../locales/en/errors.json'
import enMarketing from '../locales/en/marketing.json'

import esCommon from '../locales/es/common.json'
import esDashboard from '../locales/es/dashboard.json'
import esCalls from '../locales/es/calls.json'
import esCampaigns from '../locales/es/campaigns.json'
import esSimulations from '../locales/es/simulations.json'
import esContacts from '../locales/es/contacts.json'
import esAgents from '../locales/es/agents.json'
import esFollowups from '../locales/es/followups.json'
import esDirectory from '../locales/es/directory.json'
import esBilling from '../locales/es/billing.json'
import esAuth from '../locales/es/auth.json'
import esErrors from '../locales/es/errors.json'
import esMarketing from '../locales/es/marketing.json'

export const SUPPORTED_LANGUAGES = ['en', 'es'] as const
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number]

export const NAMESPACES = [
  'common',
  'dashboard',
  'calls',
  'campaigns',
  'simulations',
  'contacts',
  'agents',
  'followups',
  'directory',
  'billing',
  'auth',
  'errors',
  'marketing',
] as const

const resources = {
  en: {
    common: enCommon,
    dashboard: enDashboard,
    calls: enCalls,
    campaigns: enCampaigns,
    simulations: enSimulations,
    contacts: enContacts,
    agents: enAgents,
    followups: enFollowups,
    directory: enDirectory,
    billing: enBilling,
    auth: enAuth,
    errors: enErrors,
    marketing: enMarketing,
  },
  es: {
    common: esCommon,
    dashboard: esDashboard,
    calls: esCalls,
    campaigns: esCampaigns,
    simulations: esSimulations,
    contacts: esContacts,
    agents: esAgents,
    followups: esFollowups,
    directory: esDirectory,
    billing: esBilling,
    auth: esAuth,
    errors: esErrors,
    marketing: esMarketing,
  },
} as const

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: ['en', 'es'],
    defaultNS: 'common',
    ns: [...NAMESPACES],
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'voysi.lang',
    },
    resources,
    react: { useSuspense: false },
  })

if (typeof window !== 'undefined') {
  ;(window as unknown as { i18next: typeof i18n }).i18next = i18n
}

export default i18n
